import mapRange from './map-range'

/**
 * Checks if the x and y coordinates are inside the given circle.
 * @param x x position
 * @param y y position
 * @param cX circle x position
 * @param cY circle y position
 * @param radius circle radius
 * @returns if in circle or not
 */
export function inCircle(
  x: number,
  y: number,
  cX: number,
  cY: number,
  radius: number
) {
  const distPoints = (x - cX) * (x - cX) + (y - cY) * (y - cY)
  radius *= radius

  return distPoints < radius
}

/**
 * Calculate the angle between point x/y and center cX/cY.
 * @param x x position
 * @param y y position
 * @param cX circle x position
 * @param cY circle y position
 * @returns angle in degrees
 */
export function getAngle(x: number, y: number, cX: number, cY: number) {
  const rotationInPi = Math.atan2(y - cY, x - cX)
  const rotationInDeg = mapRange(rotationInPi, -Math.PI, Math.PI, 0, 360)

  // offset rotation calculation by 90 degree so 0deg is at the top
  return (rotationInDeg + 270) % 360
}

/**
 * Calculate the x/y position in a circle by the given angle and radius.
 * @param angle in degree
 * @param radius
 * @returns point x/y
 */
export function getPositionInCircle(angle: number, radius: number) {
  // Offset angle by 90 degree so 0deg is at the top
  const rotation = angle - 90

  return {
    x: radius * Math.cos((Math.PI * 2 * rotation) / 360),
    y: radius * Math.sin((Math.PI * 2 * rotation) / 360),
  }
}
